import { Button, Color, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    padding: Spacing.XXL,
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    marginBottom: Spacing.M,
  },
})

interface Props {
  onAdd?: () => void
}

const FloorplanEmpty = (props: Props) => {
  const { onAdd } = props
  const { t } = useTranslation()

  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        <Trans>There is no map for this floor yet. Add a map to specify your floor layout.</Trans>
      </Text>
      <Button title={t('Add map')} left="plus" onPress={onAdd} testID="FloorplanEmpty.Add" />
    </View>
  )
}

export default FloorplanEmpty
